/**
 * Define cell for row FIXME
 * @param {Boolean} readOnly - optional selectable
 * @param {Boolean} selectable - optional default true
 * @param {Function} children - callback function on click cell
 * @param {ChildNode} Component - Component to render as child
 * @param {String} textAling - optional align text for cell [left, right, center] default center
 * @param {String} color - define color for cell
 * @param {Array} style - define style for cell
 */

function TableRow({
  record,
  onClick,
  readOnly,
  selectable,
  children,
  onDoubleClick,
  isChecked,
  selectedRows,
}) {
  let _style = "odd:bg-white even:bg-zinc-100 h-full";
  if (isChecked) {
    console.log("este si....", isChecked);
    _style = "bg-lime-100";
  }

  if (selectable) {
    return (
      <tr
        id={record.id}
        key={record.id}
        disabled={readOnly}
        className={_style}
        onClick={() => onClick(record)}
        onDoubleClick={() => onDoubleClick(record)}
      >
        {children}
      </tr>
    );
  } else {
    return (
      <tr
        id={record.id}
        key={record.id}
        disabled={readOnly}
        className={_style}
        onClick={() => onClick(record)}
      >
        {children}
      </tr>
    );
  }
}

export default TableRow;
